import { combineReducers } from 'redux'

import routinesReducer from './routinesReducer'
import airtableReducer from './airtableReducer'

export default combineReducers({ 
    routine:routinesReducer,
    airtable:airtableReducer
})

